import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export const ProblemSection = () => {
  return <section className="w-full bg-gray-50 py-16 md:py-24" data-id="element-342">
      <div className="container mx-auto px-4 md:px-6" data-id="element-343">
        <div className="flex flex-col md:flex-row max-w-5xl mx-auto" data-id="element-344">
          <div className="md:w-1/2 md:pr-8 mb-8 md:mb-0" data-id="element-345">
            <div className="flex items-center mb-6" data-id="element-346">
              <AlertCircleIcon className="h-8 w-8 text-red-500 mr-3" data-id="element-347" />
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-348">
                Why Sleeping Pills Leave You More Tired Than Before
              </h2>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-349">
              <p className="text-gray-700 mb-4" data-id="element-350">
                If you've tried sleeping pills, you know the cycle: take a pill,
                fall unconscious, wake up groggy, struggle through the day,
                repeat. Sound familiar?
              </p>
              <p className="text-gray-700 mb-4" data-id="element-351">
                Here's what's really happening: sleeping pills don't create
                natural sleep. They chemically knock you out, skipping the deep,
                restorative stages your brain and body desperately need. That's
                why you wake up feeling like you haven't slept at all.
              </p>
              <div className="bg-red-50 border-l-4 border-red-500 p-4 my-6" data-id="element-352">
                <p className="text-red-700 font-medium" data-id="element-353">
                  Worse yet: Your body becomes dependent on them. Miss a dose?
                  Hello, rebound insomnia.
                </p>
              </div>
              <p className="text-indigo-700 font-medium text-lg" data-id="element-354">
                But here's the good news... There's a way to sleep that works
                with your body, not against it.
              </p>
            </div>
          </div>
          <div className="md:w-1/2 flex flex-col justify-center" data-id="element-355">
            <div className="bg-white rounded-lg shadow-lg p-6" data-id="element-356">
              <h3 className="text-xl font-bold text-red-600 mb-4" data-id="element-357">
                Common Sleep Medication Issues
              </h3>
              <ul className="space-y-3" data-id="element-358">
                <li className="flex items-start" data-id="element-359">
                  <div className="h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-360">
                    <span className="text-red-600 font-bold" data-id="element-361">1</span>
                  </div>
                  <p className="text-gray-700" data-id="element-362">
                    Morning grogginess that affects work and daily activities
                  </p>
                </li>
                <li className="flex items-start" data-id="element-363">
                  <div className="h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-364">
                    <span className="text-red-600 font-bold" data-id="element-365">2</span>
                  </div>
                  <p className="text-gray-700" data-id="element-366">
                    Increasing tolerance requiring higher doses over time
                  </p>
                </li>
                <li className="flex items-start" data-id="element-367">
                  <div className="h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-368">
                    <span className="text-red-600 font-bold" data-id="element-369">3</span>
                  </div>
                  <p className="text-gray-700" data-id="element-370">
                    Dependency that makes natural sleep increasingly difficult
                  </p>
                </li>
                <li className="flex items-start" data-id="element-371">
                  <div className="h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-372">
                    <span className="text-red-600 font-bold" data-id="element-373">4</span>
                  </div>
                  <p className="text-gray-700" data-id="element-374">
                    Potential long-term health consequences from chronic use
                  </p>
                </li>
              </ul>
            </div>
            <div className="mt-8 bg-indigo-50 rounded-lg shadow-md p-6" data-id="element-375">
              <h3 className="text-xl font-bold text-indigo-600 mb-4" data-id="element-376">
                The Natural Alternative
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-377">
                Setu's Sleep Restore works with your body's natural processes
                instead of forcing unconsciousness. The result is genuine,
                restorative sleep that leaves you feeling refreshed.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};